import React from "react";

import moment from 'moment';

import EffortProgress from "./EffortProgress"

import TaskItem from './TaskItem'
import Tabs from 'react-bootstrap/Tabs';
import Tab from 'react-bootstrap/Tab';
import LoadingTasks from "./LoadingTasks";
class TaskTable extends React.Component {
	constructor(props) {

		super(props);
		this.state = {
			activeTab:props.defaultSelectedTab,
			filter: {
				taskType: null,
				project: null,
				areaType: 'WORK',
				taskName: props.filterTaskName,
				showCompletedItems: false
			}
		};
		this.setTaskType = this.setTaskType.bind(this);
		this.setActiveTab = this.setActiveTab.bind(this);
		this.setSchedule = this.setSchedule.bind(this);
		this.setTaskName = this.setTaskName.bind(this);
		this.setAreaType = this.setAreaType.bind(this);
		this.setProject = this.setProject.bind(this);
		this.componentDidUpdate = this.componentDidUpdate.bind(this);
		this.setShowCompletedItems = this.setShowCompletedItems.bind(this);
		this.onScheduleTypeChange = this.onScheduleTypeChange.bind(this);
	}
	setActiveTab(tab) {
		var curState = this.state
		curState.activeTab = tab
		this.setState(curState);
	}
	onScheduleTypeChange(schedule) {

		this.props.onScheduleTypeChange(schedule);
	}
	setSchedule(schedule) {
		if (this.props.schedule !== 'NOT_SCHEDULED'
			&& this.props.schedule !== 'TODAY'
			&& this.props.schedule !== 'ALL') {
			var currentFilter = this.state.filter;

			currentFilter.showCompletedItems = true;

			this.setState(this.state, this.props.onScheduleTypeChange(schedule));
		} else {

			this.props.onScheduleTypeChange(schedule);
		}
	}

	stateFilter(state) {
		return this.state.filter.taskType === state.taskType;
	}
	taskNameFilter(state) {
		// if(this.state.filter.taskName!==undefined){
		var result = state.taskDetails.name.toUpperCase().includes(this.state.filter.taskName.toUpperCase());
		if (!result) {
			var splits = this.state.filter.taskName.toUpperCase().split(" ");
			var commonWords = ["the", "from", "with", "how", "what", "when", "why", "to", "for", "a", "all", "up", "on", "to", "check", "about", "with"]
			for (var i = 0; i < splits.length; i++) {
				if (commonWords.includes(splits[i].toLowerCase()))
					continue;
				if (state.taskDetails.name.toUpperCase().includes(splits[i])) {
					return true;
				}
			}
		}
		return result;
		// }
		// return true;
		//return this.state.filter.taskType === state.taskType;
	}
	areaFilter(state) {
		return this.state.filter.areaType === state.taskDetails.area;
	}
	scheduleFilter(state) {
		if ((this.props.schedule === 'NOT_SCHEDULED'
			|| this.props.schedule === 'TODAY')
			&& state.taskDetails.reminder === undefined){
				if (this.state.filter.showCompletedItems)
				return state.taskDetails.completedDate !== null;
				else
				return state.taskDetails.completedDate === null;
			}
		else if (this.props.schedule === 'TODAY' && state.taskDetails.reminder !== undefined) {
			var now = new Date();
			var reminderTime = new Date(state.taskDetails.reminder.time);
			var result = false;
			if (reminderTime.getFullYear() === now.getFullYear()
				&& reminderTime.getDate() === now.getDate()
				&& reminderTime.getMonth() === now.getMonth()) {
					
				if (this.state.filter.showCompletedItems)
				result = state.taskDetails.completedDate !== null;
				else
				result= state.taskDetails.completedDate === null;
			}
			else if (reminderTime < now ){
				if(state.taskDetails.completedDate === null)
			result = true;
			else
			result = false;
		}
			else
{			
	return false;
}
			return result;
		}
		else if (this.props.schedule === 'ALL' && state.taskDetails.completedDate === null)
			return true;
		else if (this.props.schedule !== "" && state.taskDetails.reminder !== undefined) {
			var filterTime = new Date(this.props.schedule);
			var reminderTime2 = new Date(state.taskDetails.reminder.time);
			if (reminderTime2.getFullYear() === filterTime.getFullYear()
				&& reminderTime2.getDate() === filterTime.getDate()
				&& reminderTime2.getMonth() === filterTime.getMonth()) {
				const today = new Date();

				today.setHours(0, 0, 0, 0);
				if (filterTime < today) {
					return state.taskDetails.completedDate !== null;
				} else {
					return state.taskDetails.completedDate === null;
				}
			}
			else {
				return false;
			}
		}
		return false;
	}
	completedItemsFilter(state) {

		/*if (!this.state.filter.showCompletedItems) {
			if (state.taskDetails.completedDate == null)
				return true;
			else
				return false;
		}
		else*/
			return true;
	}
	projectFilter(state) {
		if (state.taskDetails.project != null)
			return this.state.filter.project === state.taskDetails.project.name;
		else
			return false;
	}
	applyfilter(items) {
		if (this.state.filter.taskType != null) {
			items = items.filter(this.stateFilter, this);
		}
		if (this.state.filter.taskName != null) {
			items = items.filter(this.taskNameFilter, this);
		}

		if (this.state.filter.project != null) {
			items = items.filter(this.projectFilter, this);
		}
		if (this.state.filter.showCompletedItems != null) {
			items = items.filter(this.completedItemsFilter, this);
		}
		//items = items.filter(this.scheduleFilter, this);
		return items;
	}
	setAreaType(areaType) {
		var currentFilter = this.state.filter;
		if (areaType !== 'ALL')
			currentFilter.areaType = areaType;
		else
			currentFilter.areaType = null;
		this.setState(this.state);
	}

	setProject(project) {
		var currentFilter = this.state.filter;
		if (project !== 'ALL')
			currentFilter.project = project;
		else
			currentFilter.project = null;
		this.setState(this.state);
	}

	setTaskType(taskType) {
		var currentFilter = this.state.filter;
		if (taskType !== 'ALL')
			currentFilter.taskType = taskType;
		else
			currentFilter.taskType = null;
		this.setState(this.state);
	}

	setShowCompletedItems(taskType) {
		var currentFilter = this.state.filter;

		currentFilter.showCompletedItems = taskType.target.checked;

		this.setState(this.state);
	}
	setTaskName(taskType) {
		var currentFilter = this.state.filter;

		currentFilter.taskName = taskType.target.value;

		this.setState(this.state);
	}


	componentDidUpdate() {
		if (this.props.filterTaskName !== this.state.filter.taskName) {
			var currentFilter = this.state.filter;
			currentFilter.taskName = this.props.filterTaskName

			this.setState(this.state);
		}

	}
	render() {

		// const header = <thead><tr><td>Name</td><td>Type</td></tr></thead>;
		var filteredItems = this.applyfilter(this.props.items);
		//const filter = <table><thead><tr><td colSpan="2"><b>Filter</b></td></tr></thead><tbody>
			//<tr><td>By Schedule</td><td><ScheduledFilterComponent unscheduledItems={this.props.unscheduledItems} items={filteredItems} schedule={this.props.schedule} onScheduleTypeChange={this.onScheduleTypeChange} /></td></tr>

		//	{/*<tr><td>Show completed items</td><td><input onChange={this.setShowCompletedItems} type="checkbox" name="incompletefilter" value="Bike" /></td></tr> */}
			//{/*<tr><td>Task Name</td><td><input onChange={this.setTaskName} name="taskNamefilter" value={this.state.filter.taskName} /></td></tr> */}


			//{/*<tr><td>Project</td><td><ProjectFilterComponent items={filteredItems} onProjectChange={this.setProject} /></td></tr>*/}
		//</tbody></table>;

		if (filteredItems.length > 1) {
			filteredItems.sort(function (a, b) {
				if (a.taskDetails.priority === "HIGH"
					&& b.taskDetails.priority !== 'HIGH') {
					return -1;
				}
				else if (a.taskDetails.priority !== "HIGH"
					&& b.taskDetails.priority === 'HIGH') {
					return 1;
				} else if (a.taskDetails.priority === "HIGH"
					&& b.taskDetails.priority === 'HIGH') {
					return 0;
				}
				else if (a.taskDetails.reminder !== undefined
					&& b.taskDetails.reminder !== undefined) {
					return new Date(a.taskDetails.reminder.time) - new Date(b.taskDetails.reminder.time);
				}
				else if (a.taskDetails.reminder !== undefined
					&& b.taskDetails.reminder === undefined) {
					return -1
				}
				else if (b.taskDetails.reminder !== undefined
					&& a.taskDetails.reminder === undefined) {
					return 1
				}
				else if (a.createdDate !== undefined && b.createdDate !== undefined) {
					return new Date(b.createdDate) - new Date(a.createdDate);
				}

				return 0;
			})
		}
		var makeItem = (item, keySuffix) => {
			var detailKey = item.id + "taskItemKey" + keySuffix;
			var class1 = "";
			if (item?.taskDetails?.reminder === undefined) {
				class1 = "not-scheduled"
			}
			return <TaskItem projects={this.props.projects} categories={this.props.categories} showToast={this.props.showToast} allItems={this.props.items} className={class1} contexturl={this.props.contexturl} onItemChanged={this.props.onItemChanged} key={detailKey} item={item} items={filteredItems} />;
		};
		var personalRaw = filteredItems.filter(item => item.taskDetails.area === "PERSONAL");
		var workRaw = filteredItems.filter(item => item.taskDetails.area !== "PERSONAL");

		// Group by reminder time in a left rail; unscheduled pool at the bottom.
		// The next upcoming slot gets the accent pill so the eye lands on what's next.
		var timeIcon = (label) => {
			var hour = parseInt(label.split(':')[0], 10);
			if (hour >= 5 && hour < 12) return '🌅';
			if (hour >= 12 && hour < 17) return '☀️';
			if (hour >= 17 && hour < 21) return '🌇';
			return '🌙';
		};
		var renderRail = (rawItems) => {
			var groups = {};
			var unscheduled = [];
			rawItems.forEach(item => {
				if (item.taskDetails.reminder !== undefined) {
					var label = moment(new Date(item.taskDetails.reminder.time)).format('HH:mm');
					(groups[label] = groups[label] || []).push(item);
				} else {
					unscheduled.push(item);
				}
			});
			var labels = Object.keys(groups).sort();
			var nowLabel = moment().format('HH:mm');
			var nextLabel = this.props.schedule === 'TODAY' ? labels.find(l => l >= nowLabel) : undefined;
			var timeState = (label) => {
				if (label === nextLabel) return " rail-next";
				if (this.props.schedule === 'TODAY' && label < nowLabel) return " rail-past";
				return "";
			};
			return <div className="task-list task-rail">
				{labels.map(label => <div className={"rail-group" + timeState(label)} key={label}>
					<div className={"rail-time" + timeState(label)}><span className="rail-pill"><span className="me-1">{timeIcon(label)}</span>{label}</span></div>
					<div className="rail-cards">{groups[label].map(item => makeItem(item, ""))}</div>
				</div>)}
				{unscheduled.length > 0 && <div className="rail-group" key="unscheduled">
					<div className="rail-time rail-muted"><span className="rail-pill">—</span></div>
					<div className="rail-cards">{unscheduled.map(item => makeItem(item, ""))}</div>
				</div>}
			</div>;
		};
		var personalTitle = <span><i className="bi bi-house-heart me-1"></i>Personal<span className="tab-count">{personalRaw.length}</span></span>;
		var workTitle = <span><i className="bi bi-briefcase me-1"></i>Work<span className="tab-count">{workRaw.length}</span></span>;

		var showEffort = this.props.schedule !== 'ALL' && this.props.schedule !== 'NOT_SCHEDULED';
		var effortFor = (area) => showEffort && <EffortProgress
			areawiseCompletedEffort={area === 'PERSONAL' ? this.props.areawiseCompletedEffort.personalEffortPercentage : this.props.areawiseCompletedEffort.workEffortPercentage}
			areawiseEffort={area === 'PERSONAL' ? this.props.areawiseEffort.personalEffortPercentage : this.props.areawiseEffort.workEffortPercentage}
			isToday={this.props.schedule === 'TODAY'}
			allItems={this.props.items}
			items={filteredItems.filter(item => item.taskDetails.area === area)} />;

		var body = <Tabs
			activeKey={this.state.activeTab}
			onSelect={(k) => this.setActiveTab(k)}
			id="fill-tab-example"
			className="mb-3"
			justify
			fill
		>
			<Tab eventKey="PERSONAL" title={personalTitle}>
				{effortFor('PERSONAL')}
				{renderRail(personalRaw)}
			</Tab>
			<Tab eventKey="WORK" title={workTitle}>
				{effortFor('WORK')}
				{renderRail(workRaw)}
			</Tab>
		</Tabs>;

		return <div>
			{!this.props.isLoaded ? <LoadingTasks/> : body}
		</div>;

	}
}
export default TaskTable;
